/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbSpecificiteCoursGridDto
 */
export interface FcbSpecificiteCoursGridDto {
    /**
     * 
     * @type {string}
     * @memberof FcbSpecificiteCoursGridDto
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbSpecificiteCoursGridDto
     */
    libelle?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbSpecificiteCoursGridDto
     */
    actif?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbSpecificiteCoursGridDto
     */
    isCompanySearch?: boolean;
}

/**
 * Check if a given object implements the FcbSpecificiteCoursGridDto interface.
 */
export function instanceOfFcbSpecificiteCoursGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbSpecificiteCoursGridDtoFromJSON(json: any): FcbSpecificiteCoursGridDto {
    return FcbSpecificiteCoursGridDtoFromJSONTyped(json, false);
}

export function FcbSpecificiteCoursGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbSpecificiteCoursGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'libelle': !exists(json, 'libelle') ? undefined : json['libelle'],
        'actif': !exists(json, 'actif') ? undefined : json['actif'],
        'isCompanySearch': !exists(json, 'isCompanySearch') ? undefined : json['isCompanySearch'],
    };
}

export function FcbSpecificiteCoursGridDtoToJSON(value?: FcbSpecificiteCoursGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'libelle': value.libelle,
        'actif': value.actif,
        'isCompanySearch': value.isCompanySearch,
    };
}

